import { type ReactNode } from 'react';
import { ArrowLeft } from '@/components/ui/icons';
import { Button } from '@/components/ui/primitives';
import { LocalizedLandingPage } from '@/pages/LocalizedLandingPage';
import { EN_CONTENT } from '@/pages/landingContent';

import '@/styles/pages/LandingPage.css';
import '@/styles/pages/ViewerPage.css';

/**
 * The marketing homepage at "/". Delegates to LocalizedLandingPage with English content.
 * It NEVER auto-opens the last PDF -- root is always the homepage.
 */
export function LandingPage() {
    return <LocalizedLandingPage route="/" content={EN_CONTENT} />;
}

/* ===================================
   LOCAL VIEWER HEADER
   =================================== */

interface LocalViewerHeaderProps {
    isCalibrating: boolean;
    calibrationPointsCount: number;
    onNewPdf: () => void;
    /** The unified toolbar, rendered inline in the top bar. */
    children?: ReactNode;
}

export function LocalViewerHeader({ isCalibrating, calibrationPointsCount, onNewPdf, children }: LocalViewerHeaderProps) {
    return (
        <header className="viewer-header">
            <div className="viewer-header__left">
                <Button icon={ArrowLeft} variant="ghost" onClick={onNewPdf} className="viewer-header__back">
                    New PDF
                </Button>
            </div>

            {/* Unified toolbar (tools + view + scale + ...) lives in the top bar. */}
            {children}

            <div className="viewer-header__center">
                {isCalibrating && (
                    <div className="viewer-header__calibration-status">
                        Calibrating ({calibrationPointsCount}/2)
                    </div>
                )}
            </div>
        </header>
    );
}
